function init(){
    try {
		if (document.querySelector('.jump-links')) {

			// this hides and shows tabs
			let tablinks = $(".tablinks");

			if (tablinks != null && tablinks.length > 0) {

				let jumpDic = {};

				for (let tli = 0; tli < tablinks.length; tli++) {

					let tablink = $(tablinks[tli]);

					let tablinkTarget = tablink.attr("href");
					tablinkTarget = tablinkTarget.replace("#", "");
					jumpDic[tablinkTarget] = tablink;

					tablink.on("click", function (e) {
						let allTabContent = $(".tab-content");
						$(".tablinks").each(function (q) {
							$(this).removeClass("active").attr("aria-pressed", 'false');
							$(allTabContent[q]).removeClass("u-visible");
							$(allTabContent[q]).addClass("u-hidden");
						});
						$(this).addClass("active").attr("aria-pressed", 'true');
						$(allTabContent[tli]).removeClass("u-hidden");
						$(allTabContent[tli]).removeClass("u-visible");
					});
				}

				// this sets active status on tabs based on scrolling by an accessibility jump link
				let allJumpLinks = document.getElementsByClassName("jump-link");
				let jumplinks = document.getElementsByClassName("jump-links");
				let jumpLink = jumplinks[0];

				const observer = new IntersectionObserver(
					([e]) => e.target.classList.toggle('scrolling', e.intersectionRatio < 1),
					{
						rootMargin: '-1px 0px 0px 0px',
						threshold: [1]
					}
				);

				observer.observe(jumpLink);

				window.addEventListener("scroll", function () {
					try {
						// go in reverse order because things further down the page have priority
						for (let j = allJumpLinks.length - 1; j >= 0; j--) {

							let jl = allJumpLinks[j];

							let tablink = jumpDic[jl.id];

							if (tablink == null)
								continue;

							let scrollTarget = jl.offsetTop - 100 + jl.offsetHeight;

							if (window.scrollY > scrollTarget) {
								$(".tablinks").each(function () { $(this).removeClass("active").attr("aria-pressed", "false"); });
								tablink.addClass("active").attr("aria-pressed", 'true');
								break;
							}
						}
					}
					catch (e) {
						console.error(e);
					}
				});
			}
		}
	}
	catch (e) {
		console.error(e);
	}
	


	

}

export {init}